/*
 * All defined sequences
 * @type {Object}
 */

const sequences = {
	FETCH_USER_DATA: 'global/user/fetch-data',

	LOAD_MY_SUCCESS_HALL_OF_FAME: 'hall-of-fame-is-currently-loading',
	LOAD_MY_SUCCESS_LEVELS: 'user-levels-are-currently-loading',

	PROGRAM_IS_STARTING: 'a-program-is-currently-starting',
	PROGRAM_IS_QUITTING: 'a-program-is-currnetly-quitting',

	CARD_IS_CHECKING: 'a-card-is-currently-checking',
	TRACKING_IS_UPDATING: 'a-tracking-card-is-currently-updating',
	SLOGAN_IS_UPDATING: 'a-slogan-card-is-currently-updating',
	CARD_IS_POSTPONING: 'a-card-is-currently-postponing',

	CALENDAR_TODAY_IS_LOADING: 'the-calendar-today-is-loading',
	CALENDAR_IS_LOADING: 'the-calendar-is-loading',

	ANAMNESIS_IS_PROCESSING_STEP: 'an-anamnesis-step-is-processing-data',

	FAVORITES_IS_LOADING: 'favorites-is-loading',
	FAVORITE_IS_LOADING: 'favorite-is-loading',
	FAVORITE_IS_TOGGLING: 'favorite-item-is-toggling',

	DASHBOARD_MEASUREMENT_UPDATING: 'dashboard-is-updating',

	POOL_IS_LOADING: 'pool-is-loading',
	POOL_ITEM_IS_LOADING: 'pool-item-is-loading',

	FILTER_IS_UPDATING: 'profile-filter-is-updating',
};

export default sequences;
